module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-aai-student-image-2-sp-47aae57cfa6e49eaf95877207e0de608.jpg";